import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'id',
        sorter: (a, b) => a.id - b.id
      },
      {
        title: 'Lead ID',
        dataIndex: 'lead_id'
      },
      {
        title: 'Lead Name',
        width: 200,
        dataIndex: 'lead_name',
        sorter: (a, b) => a.lead_name.localeCompare(b.lead_name)
      },
      {
        title: 'Address',
        width: 200,
        dataIndex: 'address'
      },
      {
        title: 'Company',
        width: 200,
        dataIndex: 'company_name',
        sorter: (a, b) => a.company_name.localeCompare(b.company_name)
      },
      {
        title: 'Primary Contact',
        dataIndex: 'contact'
      },
      {
        title: 'Primary Contact Phone Number',
        dataIndex: 'contact_phone'
      },
      {
        title: 'Date Proposal Sent',
        dataIndex: 'sent_date',
        sorter: (a, b) => moment(a.sent_date).isSameOrBefore(b.sent_date)
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    return fullReport.map((item, index) => {
      item.sent_date = moment(new Date(item.sent_date)).format('YYYY-MM-DD')
      item.contact = `${item.contact_first_name} ${item.contact_last_name}`
      item.address = `${item.address1}${item.address2 ? ', ' + item.address2 : ''}, ${item.city}, ${
        item.state
      }`
      item.key = item.id
      return item
    })
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Proposals</h5>
                </div>
              </div>
              <Table
                pagination={false}
                columns={this.getColumns()}
                dataSource={this.getData()}
                size="small"
                style={{ backgroundColor: 'white' }}
              />
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/leads/proposals-sent/ListItem.js